// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { WorkspaceId } from '@jira/servicedesk__insight-common-types-shared-types/src/toCmdbObjectTypeId.tsx';
import fetchWorkspaceId from './fetchWorkspaceId.tsx';
import { WORKSPACE_CONTEXT_RESOURCE_KEY } from './workspaceResourceConstants.tsx';

export const workspaceResource: RouteResource<string | null> = createResource<WorkspaceId | null>({
	type: 'JSM_INSIGHT_WORKSPACE_CONTEXT',
	getKey: () => WORKSPACE_CONTEXT_RESOURCE_KEY,
	getData: async (_, routerContext) => {
		const workspaceId = await fetchWorkspaceId(_, routerContext);
		return workspaceId;
	},
	maxAge: Infinity,
});
